import createModal from '../components/createModal';
import { $ } from '../util/DOM';

const videoView = (p) => {
  const html = $('.videos__template', p);

  const modal = createModal(html[0].innerHTML, true);

  return modal;
};

const initVideos = () => {
  $('.videos__container').forEach((container) => {
    const photos = $('.videos__item', container);
    photos.forEach((p, index) => {
      // eslint-disable-next-line no-param-reassign
      p.modal = videoView(p, (i) => {
        const selectedIndex = index + i;
        p.modal.close();
        if (selectedIndex < 0) {
          photos[photos.length - 1].modal.open();
          return;
        }
        if (selectedIndex >= photos.length) {
          photos[0].modal.open();
          return;
        }
        photos[selectedIndex].modal.open();
      });

      p.addEventListener('click', (e) => {
        e.preventDefault();
        p.modal.open();
      });
    });
  });
};

export default initVideos;
